/**
 * Query keys das integrações do clube com parceiros (`club_integrations`).
 *
 * A RAIZ É `['club_integrations']`, igual aos literais que já existem no CRM
 * (useClubIntegrations, status da Wellhub): invalidar `integrations.all` pega
 * esses também por prefix-match, enquanto eles não migram para a factory.
 */
import { tuple } from "./core";

const root = ["club_integrations"] as const;

export const integrations = {
  all: root,
  /** Status da unidade TotalPass de um clube (`totalpass_status_da_unidade`). */
  totalpassStatus: (clubId: string | null | undefined) => tuple(root, clubId, "totalpass_status"),
  /**
   * Os parceiros com repasse por validação DA UNIDADE (`useIntegracoesDaUnidade`
   * no CRM). Fica sob a raiz: ligar, desligar ou conectar uma integração
   * invalida `integrations.all` e a aba Repasse relê junto.
   */
  parceirosDoRepasse: (clubId: string | null | undefined) => tuple(root, clubId, "parceiros_do_repasse"),
} as const;
